import { useContext } from "react";

import Context from "../../context";
import useGetTransferPositions from "../../hooks/useGetTransferPositions";

const useCheckSelectedPositions = () => {
	const { state } = useContext(Context);
	const selectedPositions = state.selectedPositions;

	const { positions } = useGetTransferPositions();

	const disabled =
		selectedPositions.some((i) => {
			const position = positions.find((p) => p.positionId === i.id)!;
			if (i.shares === undefined) return false;
			return i.shares === null || i.shares > position.titles || i.shares <= 0;
		}) || selectedPositions.length === 0;

	return {
		isDisabled: disabled
	};
};

export default useCheckSelectedPositions;
